import { PaymentErrorShortCodes } from '../Interfaces';
import { PaymentValidationError } from '../Errors';
var BillingContact = /** @class */ (function () {
    function BillingContact(billingContactInfo) {
        var _a, _b;
        this.name = {
            first: BillingContact.formatFirstName((_a = billingContactInfo === null || billingContactInfo === void 0 ? void 0 : billingContactInfo.name) === null || _a === void 0 ? void 0 : _a.first),
            middle: BillingContact.formatMiddleName(billingContactInfo.name.middle),
            last: BillingContact.formatLastName(billingContactInfo.name.last)
        };
        this.address = {
            address1: BillingContact.formatAddress1((_b = billingContactInfo.address) === null || _b === void 0 ? void 0 : _b.address1),
            address2: BillingContact.formatAddress2(billingContactInfo.address.address2),
            address3: BillingContact.formatAddress3(billingContactInfo.address.address3),
            city: BillingContact.formatCity(billingContactInfo.address.city),
            state: BillingContact.formatState(billingContactInfo.address.state),
            country: BillingContact.formatCountry(billingContactInfo.address.country),
            zip: BillingContact.formatZip(billingContactInfo.address.zip)
        };
        if (billingContactInfo.contactInfo) {
            BillingContact.validateIPAddress(billingContactInfo.contactInfo.ipAddress);
            this.contactInfo = {
                phone: BillingContact.formatPhoneNumber(billingContactInfo.contactInfo.phone),
                email: BillingContact.formatEmail(billingContactInfo.contactInfo.email),
                ipAddress: billingContactInfo.contactInfo.ipAddress ? billingContactInfo.contactInfo.ipAddress : undefined
            };
        }
    }
    BillingContact.formatFirstName = function (firstName) {
        BillingContact.isValidName(firstName, 'First', PaymentErrorShortCodes.invalid_first_name);
        return firstName;
    };
    BillingContact.formatMiddleName = function (middleName) {
        var formattedMiddleName = undefined;
        if (middleName && middleName.length > 0) {
            BillingContact.isValidName(middleName, 'Middle', PaymentErrorShortCodes.invalid_middle_name);
            formattedMiddleName = middleName;
        }
        return formattedMiddleName;
    };
    BillingContact.formatLastName = function (lastName) {
        BillingContact.isValidName(lastName, 'Last', PaymentErrorShortCodes.invalid_last_name);
        return lastName;
    };
    BillingContact.isValidName = function (name, nameType, errorShortCode) {
        if (!name || name.length > 50) {
            throw new PaymentValidationError("".concat(nameType, " name contains illegal characters or has illegal format"), errorShortCode);
        }
        return true;
    };
    BillingContact.formatAddress1 = function (address1) {
        var formattedAddress1 = undefined;
        if (address1 && address1.length > 0) {
            BillingContact.isValidAddress(address1, 1, PaymentErrorShortCodes.invalid_address_1);
            formattedAddress1 = address1;
        }
        return formattedAddress1;
    };
    BillingContact.formatAddress2 = function (address2) {
        var formattedAddress2 = undefined;
        if (address2 && address2.length > 0) {
            BillingContact.isValidAddress(address2, 2, PaymentErrorShortCodes.invalid_address_2);
            formattedAddress2 = address2;
        }
        return formattedAddress2;
    };
    BillingContact.formatAddress3 = function (address3) {
        var formattedAddress3 = undefined;
        if (address3 && address3.length > 0) {
            BillingContact.isValidAddress(address3, 3, PaymentErrorShortCodes.invalid_address_3);
            formattedAddress3 = address3;
        }
        return formattedAddress3;
    };
    BillingContact.isValidAddress = function (address, addressType, errorShortCode) {
        if (!address || address.length > 100) {
            throw new PaymentValidationError("Address ".concat(addressType, " contains illegal characters or has illegal format"), errorShortCode);
        }
        return true;
    };
    BillingContact.formatCity = function (city) {
        var formattedCity = undefined;
        if (city && city.length > 0) {
            BillingContact.isValidCity(city);
            formattedCity = city;
        }
        return formattedCity;
    };
    BillingContact.isValidCity = function (city) {
        if (!city || city.length > 100) {
            throw new PaymentValidationError("City contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_city);
        }
        return true;
    };
    BillingContact.formatState = function (state) {
        var formattedState = undefined;
        if (state && state.length > 0) {
            BillingContact.isValidState(state);
            formattedState = state;
        }
        return formattedState;
    };
    BillingContact.isValidState = function (state) {
        if (!state || state.length > 35) {
            throw new PaymentValidationError("State contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_state);
        }
        return true;
    };
    BillingContact.formatCountry = function (country) {
        BillingContact.isValidCountry(country);
        return country;
    };
    BillingContact.isValidCountry = function (country) {
        if (!/^[a-zA-Z]{1,2}$/.test(country)) {
            throw new PaymentValidationError("Country contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_country);
        }
        return true;
    };
    BillingContact.formatZip = function (zip) {
        BillingContact.isValidZip(zip);
        return zip;
    };
    BillingContact.isValidZip = function (zip) {
        if (!/^[a-zA-Z0-9 -]{1,10}$/.test(zip)) {
            throw new PaymentValidationError("ZIP contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_zip);
        }
        return true;
    };
    BillingContact.formatPhoneNumber = function (phone) {
        var formattedPhone = undefined;
        if (phone && phone.length > 0) {
            BillingContact.isValidPhoneNumber(phone);
            formattedPhone = phone;
        }
        return formattedPhone;
    };
    BillingContact.isValidPhoneNumber = function (phone) {
        if (!phone || phone.length > 15) {
            throw new PaymentValidationError("Phone number contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_phone);
        }
        return true;
    };
    BillingContact.formatEmail = function (email) {
        var formattedEmail = undefined;
        if (email && email.length > 0) {
            BillingContact.isValidEmail(email);
            formattedEmail = email;
        }
        return formattedEmail;
    };
    BillingContact.isValidEmail = function (email) {
        if (!email) {
            throw new PaymentValidationError("Email contains illegal characters or has illegal format", PaymentErrorShortCodes.invalid_email);
        }
        return true;
    };
    // ipv4 regex, meaning:
    // a group of 1-3 digits, in range 0-255, with no leading zeroes
    // that group repeated 4 times, with '.' separating each group
    // and nothing else
    // https://stackoverflow.com/questions/5284147/validating-ipv4-addresses-with-regexp
    BillingContact.validateIPAddress = function (ip) {
        if (!ip)
            return;
        if (!/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/.test(ip)) {
            throw new PaymentValidationError('IP address has invalid format or illegal characters', PaymentErrorShortCodes.invalid_ip);
        }
    };
    return BillingContact;
}());
export { BillingContact };
